import { render } from "./TeamStats.vue?vue&type=template&id=76d3acb2"
import script from "./TeamStats.vue?vue&type=script&lang=js"
export * from "./TeamStats.vue?vue&type=script&lang=js"

import "./TeamStats.vue?vue&type=style&index=0&id=76d3acb2&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__